import * as React from "react";
import { useState } from "react";
import { useMount } from "../../../../utils/custom-hooks";
import { MFAService } from "../../../../application/service/smart-apply/mfa/mfa-service";
import { InputWithButton } from "../../../molecules/input-with-button";
import { Spinner } from "@graffer-inc/console-design-kit";

interface InitTOTPProps {
  init: typeof MFAService.prototype.initTOTP;
  enable: (TOTP: string) => void;
}

export const InitTOTP: React.FunctionComponent<InitTOTPProps> = ({
  init,
  enable,
}) => {
  const [initTOTPData, setInitTOTPData] = useState<{
    qr: Uint8Array;
    key: string;
  } | null>(null);

  useMount(async () => setInitTOTPData(await init()));

  if (!initTOTPData) {
    return <Spinner loading={true} />;
  }

  return (
    <section>
      <h2>
        モバイル端末にインストールした認証アプリで認証コードを取得します。
      </h2>
      <h3 style={{ fontSize: "18px" }}>
        <span className="stepNumber">1</span>Google認証システム(Google
        Authenticator)などの認証アプリをダウンロードします。
      </h3>

      <h3 style={{ fontSize: "18px" }}>
        <span className="stepNumber">2</span>
        下記の二次元コードをモバイル端末で読み取ります。
      </h3>
      <div className="column is-half">
        <div style={{ border: "8px solid #f2f2f2", width: 310, height: 310 }}>
          <img src={`data:image/png;base64,${initTOTPData.qr}`} alt="qrcode" />
        </div>
      </div>
      <p style={{ marginTop: "5px", marginBottom: "5px" }}>
        二次元コードが読み取れない場合は、シークレットキーを認証アプリに入力して下さい。
      </p>
      <p className="secretKey"> {initTOTPData.key}</p>
      <h3 style={{ fontSize: "18px" }}>
        <span className="stepNumber">3</span>
        認証アプリに表示されている6桁の認証コードを入力して下さい。
      </h3>
      <div className="column is-4 is-paddingless">
        <InputWithButton
          onSubmit={enable}
          type="password"
          btnName="認証"
          placeholder={"認証コード(6桁)"}
        />
      </div>
    </section>
  );
};
